import styled from 'styled-components';

import { FlexDiv, GenericP } from 'commonStyles';

export const DocsBannerWrapper = styled(FlexDiv)`
	background-position: 0 -120px;
	background-size: contain;
`;

export const DocsBannerHeading = styled(GenericP)`
	display: inline-block;
	background: linear-gradient(91deg, #98C2D3 -8.76%, rgba(152, 194, 211, 0.08) 111.05%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
`;
